const MAIN_BACKGROUND = 'primary'
const MAIN_COLOR = 'white'
const MAIN_COLOR_DARK = 'black'

const TYPE_SUCCESS = 'success'
const TYPE_WARNING = 'warning'
const TYPE_ERROR = 'error'
const TYPE_INFO = 'info'

const GROUP_ADMIN = 'Administrator'
const GROUP_COACH = 'Coach'
const GROUP_EMPLOYEE_SMART = 'EmployeeSmart'
const GROUP_EMPLOYEE_SANE = 'EmployeeSane'
const GROUP_EMPLOYEE_DUMB = 'EmployeeDumb'
const GROUP_DISABLED = 'Disabled'

const FORMAT_PERCENT = '0%'
const FORMAT_RATING = '0.00'

const CONSTANTS = {
    DEFAULT_SETTINGS: {
        theme: 'light',
        language: 'German',
        dense: false,
        dateFormat: 'iso'
    },

    DATE_FORMATTER: {
        iso: {
            datetime: 'YYYY-MM-DD HH:mm',
            date: 'YYYY-MM-DD',
            time: 'HH:mm',
            daymonth: 'MM-DD'
        },
        de: {
            datetime: 'DD.MM.YYYY HH:mm',
            date: 'DD.MM.YYYY',
            time: 'HH:mm',
            daymonth: 'DD.MM'
        },
        en: {
            datetime: 'YYYY/DD/MM HH:mm',
            date: 'YYYY/DD/MM',
            time: 'HH:mm',
            daymonth: 'DD/MM'
        }
    },

    RELOAD_INTERVAL: 60000, // in ms
    REFRESH_TOKEN__MIN: 5, // refresh token when minutes to expire is lower than this

    ROUTES: {
        USERS_LOGIN: 'users/login',
        USERS_LOGOUT: 'users/logout',
        USERS_GET: 'users/get',
        USERS_CREATE: 'users/create',
        USERS_RESET_PW: 'users/resetpassword',
        USERS_FORGOT_PW: 'users/resetforgottenpassword',
        USERS_UPDATE: 'users/update',
        USERS_DELETE: 'users/delete',
        USERS_SETTINGS: 'users/settings',
        USERS_VERIFY: 'users/verifyemail',
        USERS_REFRESH_TOKEN: 'users/refreshtoken',
        USERS_ACCEPT_INVITATION: 'users/acceptinvitation',
        USERS_INVITATIONS: 'users/invitations', // /{userId}

        ORG_ALL: 'organisations/all',
        ORG_GET: 'organisations/get',
        ORG_LIST: 'organisations/list', // GET:/?organizationList=id1,id2,..
        ORG_CREATE: 'organisations/create',
        ORG_UPDATE: 'organisations/update',
        ORG_DELETE: 'organisations/delete',
        // GET:/
        // DELETE:/{organizationId}/{userId}
        ORG_USERS: 'organisations/users',
        ORG_USER: 'organisations/user',
        ORG_USERGROUP: 'organisations/usergroup', // PUT {organisationId, userId, organizationGroup}
        ORG_ORGUSER: 'organisations/organisationuser',
        ORG_BLOCKS: 'organisations/buildingblocks',
        ORG_TPLS: 'organisations/templates',
        ORG_COACHING: 'organisations/coaching',
        ORG_INVITE: 'organisations/invite',
        ORG_INVITATIONS: 'organisations/invitations', // GET:/{organizationId}
        ORG_INVITATION_DELETE: 'organisations/invitation', // DELETE:/{organizationId}/{actionTokenId}
        ORG_OVERVIEW: 'organisations/overview', // GET:/{organizationId}
        ORG_HISTORY: 'organisations/historywidget', // GET:/{organizationId}
        ORG_SEND_PDF: 'organisations/sendcoachingpdf',

        TPLS_CREATE: 'templates/create',
        TPLS_UPDATE: 'templates/update',
        TPLS_DELETE: 'templates/delete',

        BLOCKS_CREATE: 'buildingblocks/create',
        BLOCKS_UPDATE: 'buildingblocks/update',
        BLOCKS_DELETE: 'buildingblocks/delete',

        COACHING_GET: 'coaching/get', // GET:/{coachingId}
        COACHING_CREATE: 'coaching/create',
        COACHING_UPDATE: 'coaching/update',
        COACHING_DELETE: 'coaching/delete',

        COACHING_UNIT_GET: 'CoachingUnits/Get', // GET:/{coachingUnitId}
        COACHING_UNIT_LIST: 'CoachingUnits/List', // GET:?organisationId={organisationId}
        COACHING_UNIT_CREATE: 'CoachingUnits/Create',
        COACHING_UNIT_UPDATE: 'CoachingUnits/Update',
        COACHING_UNIT_SET_DONE: 'CoachingUnits/SetDone', // PUT:/{coachingUnitId}
        COACHING_UNIT_DELETE: 'CoachingUnits/Delete', // DELETE:/{coachingUnitId}

        ACTIONTOKEN_VALID: 'actiontokens/isvalid' // GET:/{actionTokenId}
    },

    MAIN_BACKGROUND,
    MAIN_COLOR,
    MAIN_COLOR_DARK,

    COACHING_FILTER_STATUS: ['both', 'finished', 'unfinished'],

    DEFAULT_TABLE_CONFIG: {
        table: {
            disablePagination: false,
            hideDefaultFooter: false,
            class: 'elevation-4',
            mustSort: true,
            itemsPerPage: 10,
            footerProps: {
                itemsPerPageOptions: [5, 10, 20, 50, 100, -1]
            }
        },
        toolbar: {
            class: 'flat elevation-0',
            color: MAIN_BACKGROUND
        },
        title: {
            class: 'font-weight-bold'
        },
        filter: {
            dense: true,
            hideDetails: true,
            spellcheck: false,
            clearable: true,
            singleLine: true,
            solo: true,
            flat: true,
            maxWidth: '200px',
            style: 'max-width: 200px'
        },
        select: {
            hideDetails: true,
            dense: true,
            solo: true,
            flat: true,
            maxWidth: '160px',
            style: 'max-width: 160px'
        },
        checkbox: {
            hideDetails: true,
            dark: true,
            color: 'white',
            maxWidth: '150px',
            style: 'max-width: 150px'
        }
    },

    DEFAULT_HIGHLIGHT_OPTIONS: {
        wordsOnly: false,
        caseSensitive: false,
        notGlobal: true
    },

    TYPE_SUCCESS,
    TYPE_WARNING,
    TYPE_ERROR,
    TYPE_INFO,

    NAMING_BLOCK: [
        [
            {
                name: 'name',
                label: 'Name',
                maxlength: 100,
                required: true
            }
        ],
        [
            {
                name: 'description',
                label: 'Beschreibung',
                type: 'textarea',
                rows: 3,
                maxlength: 500,
                required: true
            }
        ],
        [
            {
                name: 'initials',
                label: 'Kürzel',
                maxlength: 10,
                uppercase: true,
                required: true
            }
        ]
    ],

    COLUMN_DELIMITER: ';',
    ROW_DELIMITER: '\n',

    GROUP_ADMIN,
    GROUP_COACH,
    GROUP_EMPLOYEE_SMART,
    GROUP_EMPLOYEE_SANE,
    GROUP_EMPLOYEE_DUMB,
    GROUP_DISABLED,
    GROUPS: [
        GROUP_ADMIN,
        GROUP_COACH,
        GROUP_EMPLOYEE_SMART,
        GROUP_EMPLOYEE_SANE,
        GROUP_EMPLOYEE_DUMB,
        GROUP_DISABLED
    ],
    GROUPS_EDIT: [
        GROUP_ADMIN,
        GROUP_COACH
    ],
    GROUPS_INVITATION: [
        GROUP_ADMIN,
        GROUP_COACH,
        GROUP_EMPLOYEE_SMART
    ],
    GROUPS_EMPLOYEE: [
        GROUP_EMPLOYEE_SMART,
        GROUP_EMPLOYEE_SANE,
        GROUP_EMPLOYEE_DUMB
    ],

    EMPLOYEE_IMPORT_EXPORT_COLUMNS: ['organizationGroup', 'email', 'username', 'firstname', 'lastname'],

    FORMAT_PERCENT,
    FORMAT_RATING,

    REGEXP: {
        DATE: new RegExp(/\d{4}-[0-1]\d-[0-3]\d/),
        TIME: new RegExp(/[0-2]\d:[0-5]\d/),
        DATETIME: new RegExp(/\d{4}-[0-1]\d-[0-3]\d [0-2]\d:[0-5]\d/)
    },

    // dummy fieldlist to group blocks without fieldlist
    DEFAULT_FIELDLIST: {
        id: '_NOGROUP',
        initials: '_NOGROUP',
        name: '???', // will be translated to app language
        description: '???' // will be translated to app language
    },

    ERRORS: {
        title: 'Problem',
        defaultMessage: 'Es ist ein unerwarteter Fehler aufgetreten!',
        status403Message: 'Der Zugriff wurde verweigert!'
    }
}

export default CONSTANTS
